(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9523],{

/***/ 4307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_EmptyStore; }
});

// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(5551);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/illustrations/Smiley.jsx



var Smiley = function Smiley(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "50",
    height: "51",
    className: className,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M25 0.0273438C38.7851 0.0273438 50 11.2423 50 25.0273C50 38.8124 38.7851 50.0273 25 50.0273C11.2149 50.0273 0 38.8124 0 25.0273C1.41389e-05 11.2423 11.2149 0.0273579 25 0.0273438ZM25 2.50781C12.5823 2.50787 2.47955 12.6106 2.47949 25.0283C2.47949 37.4461 12.5819 47.5488 25 47.5488C37.4178 47.5488 47.5205 37.4461 47.5205 25.0283C47.5205 12.6106 37.4177 2.50781 25 2.50781Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M38.792 19.553C38.792 21.7352 37.0228 23.5045 34.8401 23.5045C32.6579 23.5045 30.8887 21.7352 30.8887 19.553C30.8887 17.3708 32.6579 15.6016 34.8401 15.6016C37.0228 15.6016 38.792 17.3708 38.792 19.553Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.1114 19.553C19.1114 21.7352 17.3421 23.5045 15.1599 23.5045C12.9772 23.5045 11.208 21.7352 11.208 19.553C11.208 17.3708 12.9772 15.6016 15.1599 15.6016C17.3421 15.6016 19.1114 17.3708 19.1114 19.553Z",
      fill: color
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M32.3609 32.0313C31.0776 32.0313 30.3685 32.4844 29.8509 32.816C29.454 33.0694 29.2361 33.2095 28.6783 33.2095C28.1205 33.2095 27.9017 33.0694 27.5048 32.816C26.9872 32.4848 26.2781 32.0313 24.9948 32.0313C23.7124 32.0313 23.0038 32.4844 22.4871 32.816C22.0901 33.0694 21.8727 33.2095 21.3149 33.2095C20.7588 33.2095 20.5405 33.0698 20.1453 32.8164C19.6282 32.4852 18.92 32.0317 17.638 32.0317C16.9536 32.0317 16.3984 32.5873 16.3984 33.2713C16.3984 33.9557 16.954 34.5109 17.638 34.5109C18.1941 34.5109 18.4124 34.6505 18.8076 34.9039C19.3247 35.2351 20.0329 35.6887 21.3149 35.6887C22.5982 35.6887 23.3064 35.2351 23.8235 34.9039C24.2204 34.6505 24.4379 34.5109 24.9953 34.5109C25.553 34.5109 25.7718 34.651 26.1688 34.9043C26.6863 35.2356 27.3954 35.6891 28.6787 35.6891C29.9612 35.6891 30.6702 35.236 31.1878 34.9043C31.5847 34.651 31.8027 34.5109 32.3613 34.5109C33.0458 34.5109 33.6009 33.9553 33.6009 33.2713C33.6005 32.5873 33.0453 32.0312 32.3609 32.0312V32.0313Z",
      fill: color
    })]
  });
};

/* harmony default export */ var illustrations_Smiley = (Smiley);
;// CONCATENATED MODULE: ./components/EmptyStore.jsx






var EmptyStore = function EmptyStore(_ref) {
  var _store$store, _store$store2, _store$store2$contact;

  var store = _ref.store,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search,
      _ref$searchQuery = _ref.searchQuery,
      searchQuery = _ref$searchQuery === void 0 ? "" : _ref$searchQuery;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,utils.cn)("flex w-full items-center justify-center", search && "items-start", !search && "flex-col"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-[10vh] flex w-[calc(var(--max-width)-200px)] flex-col items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(illustrations_Smiley, {
        className: "mt-12 size-[96px]",
        color: "var(--font-background)"
      }), search ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-4 text-center text-[20px] italic leading-[1.5] text-fontBackground",
        children: ["Looks like we don\u2019t have ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
          children: searchQuery
        }), ".", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Check the spelling or try a different item."]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-5 text-center text-[28px] font-bold text-fontBackground",
          children: "Oh deer, it\u2019s empty!"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-2 text-center text-[16px] italic leading-[1.5] text-fontBackground",
          children: [store === null || store === void 0 ? void 0 : (_store$store = store.store) === null || _store$store === void 0 ? void 0 : _store$store.storeName, " haven't added any", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " products to their shop yet.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " If you'd like to see them here, we'd", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " love for you to drop them an invite."]
        })]
      })]
    }), !search && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "instagram://user?username=".concat(store === null || store === void 0 ? void 0 : (_store$store2 = store.store) === null || _store$store2 === void 0 ? void 0 : (_store$store2$contact = _store$store2.contactInfo) === null || _store$store2$contact === void 0 ? void 0 : _store$store2$contact.instagramHandle),
      className: "mt-6 rounded-lg border border-primary bg-primary px-14 py-2.5 text-fontPrimary hover:cursor-pointer",
      children: "INVITE"
    })]
  });
};

/* harmony default export */ var components_EmptyStore = (EmptyStore);

/***/ }),

/***/ 9523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ MainHome; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(6971);
// EXTERNAL MODULE: ./contexts/StoreDataContext.js + 1 modules
var StoreDataContext = __webpack_require__(3104);
// EXTERNAL MODULE: ./components/Footer/Footer.jsx + 2 modules
var Footer = __webpack_require__(6268);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(5551);
// EXTERNAL MODULE: ./components/Infobanner/static-infobanner.module.css
var static_infobanner_module = __webpack_require__(4555);
var static_infobanner_module_default = /*#__PURE__*/__webpack_require__.n(static_infobanner_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Infobanner/StaticInfoBanner.jsx




function StaticInfoBanner(_ref) {
  var text = _ref.text;
  if (text) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (0,utils.cn)((static_infobanner_module_default()).infobanner, "!bg-primary !text-fontPrimary"),
      children: text
    })
  });
  return null;
}
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8950);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9955);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(2186);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7039);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(3246);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intersection-observer@8.34.0_react@18.3.1/node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(1003);
// EXTERNAL MODULE: ./node_modules/.pnpm/resize-observer-polyfill@1.5.1/node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(3023);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(7191);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(6587);
// EXTERNAL MODULE: ./services/helper.js + 23 modules
var helper = __webpack_require__(3236);
;// CONCATENATED MODULE: ./hooks/useStoreProducts.js






var fetchProducts = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var queryKey, _ref$pageParam, pageParam, _queryKey, storeId, collection, url, response, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryKey = _ref.queryKey, _ref$pageParam = _ref.pageParam, pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
            _queryKey = (0,slicedToArray/* default */.Z)(queryKey, 3), storeId = _queryKey[1], collection = _queryKey[2];
            url = "".concat((0,helper/* getPublicServerEndpoint */.rq)(), "/v3/product/store/").concat(storeId, "/collectionv2?page=").concat(pageParam, "&limit=", 20, "&source=web");

            if (collection && collection !== "all") {
              url += "&collectionId=".concat(collection);
            }

            _context.next = 6;
            return fetch(url);

          case 6:
            response = _context.sent;

            if (response.ok) {
              _context.next = 9;
              break;
            }

            throw new Error("Failed to fetch products");

          case 9:
            _context.next = 11;
            return response.json();

          case 11:
            data = _context.sent;
            return _context.abrupt("return", {
              products: data.data.docs,
              nextPage: pageParam + 1,
              previousPage: pageParam > 1 ? pageParam - 1 : null,
              hasNextPage: data.data.hasNextPage
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProducts(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useStoreProducts = function useStoreProducts(storeId, collection) {
  return (0,useInfiniteQuery/* useInfiniteQuery */.N)(["storeProducts", storeId, collection], fetchProducts, {
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? lastPage.nextPage : undefined;
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
    keepPreviousData: true,
    enabled: !!storeId
  });
};

/* harmony default export */ var hooks_useStoreProducts = (useStoreProducts);
// EXTERNAL MODULE: ./pages/500.js
var _500 = __webpack_require__(3531);
// EXTERNAL MODULE: ./services/frontend/CartStorage.js + 2 modules
var CartStorage = __webpack_require__(9150);
// EXTERNAL MODULE: ./components/Cart/Basket.jsx + 1 modules
var Basket = __webpack_require__(7027);
// EXTERNAL MODULE: ./components/EmptyStore.jsx + 1 modules
var EmptyStore = __webpack_require__(4307);
// EXTERNAL MODULE: ./components/Navbar/index.jsx + 1 modules
var Navbar = __webpack_require__(7817);
// EXTERNAL MODULE: ./components/SideNavDrawer.jsx + 2 modules
var SideNavDrawer = __webpack_require__(2130);
// EXTERNAL MODULE: ./components/Skeleton.jsx
var Skeleton = __webpack_require__(1284);
// EXTERNAL MODULE: ./components/SkeletonCard.jsx
var SkeletonCard = __webpack_require__(9879);
;// CONCATENATED MODULE: ./components/CollectionFilter.jsx



var CollectionFilter = function CollectionFilter(_ref) {
  var collection = _ref.collection,
      selectedCollection = _ref.selectedCollection,
      setFilter = _ref.setFilter,
      theme = _ref.theme;
  //console.log("CollectionFilter ", collection.name, selectedCollection.name);
  var isSelected = (collection === null || collection === void 0 ? void 0 : collection.name) === (selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection.name);

  var handleClick = function handleClick() {
    if (!isSelected) {
      console.log("set filter ", collection);
      setFilter(collection);
    }
  };

  var isThemePresent = !!(theme !== null && theme !== void 0 && theme.primaryColor) && !!(theme !== null && theme !== void 0 && theme.backgroundColor);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "m-[4px_5px_5px_4px] flex h-[40px] select-none items-center justify-center whitespace-nowrap rounded-[20px] px-5 text-[13px] capitalize tracking-[1px] ".concat(isSelected ? "text-fontPrimary bg-primary" : isThemePresent ? "text-fontBackground bg-secondary" : "text-fontBackground bg-appGray"),
    onClick: handleClick,
    children: collection.name ? collection.name : "All Products"
  });
};

/* harmony default export */ var components_CollectionFilter = (CollectionFilter);
;// CONCATENATED MODULE: ./components/StoreCollections.jsx






var StoreCollections = function StoreCollections(_ref) {
  var collections = _ref.collections,
      setFilter = _ref.setFilter,
      selectedCollection = _ref.selectedCollection,
      theme = _ref.theme;
  var router = (0,next_router.useRouter)();
  var collectionRefs = (0,react.useRef)({});
  var storeCollections = (0,react.useMemo)(function () {
    var list = []; // Add "All Products" pill with ref

    list.push( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: function ref(el) {
        collectionRefs.current["all-products"] = el;
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
        collection: ALL_PRODUCTS_OBJECT,
        selectedCollection: selectedCollection,
        setFilter: setFilter,
        theme: theme
      })
    }, "initial")); // Add collection pills with refs

    var collectionList = collections.map(function (collection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: function ref(el) {
          var _collection$name;

          collectionRefs.current[(_collection$name = collection.name) === null || _collection$name === void 0 ? void 0 : _collection$name.toLowerCase()] = el;
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
          collection: collection,
          selectedCollection: selectedCollection,
          setFilter: setFilter,
          theme: theme
        })
      }, collection._id);
    });
    return list.concat(collectionList);
  }, [collections, selectedCollection, setFilter]); // Handle scroll to active collection on URL change

  (0,react.useEffect)(function () {
    var collectionParam = router.query.collection;

    if (collectionParam) {
      var targetKey = collectionParam.toLowerCase();
      var targetRef = collectionRefs.current[targetKey];

      if (targetRef) {
        setTimeout(function () {
          targetRef.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        }, 100);
      }
    }
  }, []);
  return collections.length ? storeCollections : null;
};

/* harmony default export */ var components_StoreCollections = (StoreCollections);
// EXTERNAL MODULE: ./components/StoreItem.jsx + 1 modules
var StoreItem = __webpack_require__(1041);
// EXTERNAL MODULE: ./components/Home/RestorableList.jsx
var RestorableList = __webpack_require__(4567);
;// CONCATENATED MODULE: ./components/Home/CollectionHome.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var ALL_PRODUCTS_OBJECT = {
  name: "all products",
  _id: "all"
};

var CollectionHome = function CollectionHome(_ref) {
  var _cart$products;

  var store = _ref.store,
      theme = _ref.theme,
      hasBanner = _ref.hasBanner;
  var router = (0,next_router.useRouter)();
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var isProplanActive = context.isProplanActive;
  var hasBannerWithProPlan = isProplanActive && hasBanner;

  var _useState = (0,react.useState)(ALL_PRODUCTS_OBJECT),
      selectedCollection = _useState[0],
      setSelectedCollection = _useState[1];

  var _useState2 = (0,react.useState)(null),
      lastEl = _useState2[0],
      setLastEl = _useState2[1];

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var _useStoreProducts = hooks_useStoreProducts(store.id, selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection._id),
      productData = _useStoreProducts.data,
      isProductsLoading = _useStoreProducts.isLoading,
      isFetchingNextPage = _useStoreProducts.isFetchingNextPage,
      fetchNextPage = _useStoreProducts.fetchNextPage,
      hasNextPage = _useStoreProducts.hasNextPage,
      productError = _useStoreProducts.error;

  var _useCollection = (0,useCollection/* default */.ZP)(store.id, ""),
      collectionsData = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading,
      collectionsError = _useCollection.error; // Assuming collectionsData is now structured as { collections: [...] }


  var collections = collectionsData ? collectionsData.collections : []; //console.log("shubham", collectionsData);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  var products = (productData === null || productData === void 0 ? void 0 : productData.pages.flatMap(function (page) {
    return page.products;
  })) || [];

  var _useState3 = (0,react.useState)(CartStorage/* default.getInitialCart */.Z.getInitialCart()),
      cart = _useState3[0],
      setCart = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showCart = _useState4[0],
      setShowCart = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showSideNav = _useState5[0],
      setShowSideNav = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isCartInitialized = _useState6[0],
      setIsCartInitialized = _useState6[1]; // Initialize cart from CartStorage when component mounts


  (0,react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var initialCartData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CartStorage/* default.initializeCart */.Z.initializeCart();

              case 2:
                initialCartData = _context.sent;
                setCart(initialCartData);
                setIsCartInitialized(true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref2.apply(this, arguments);
      };
    }();

    initialize();
  }, []); // Update CartStorage when cart changes

  (0,react.useEffect)(function () {
    if (cart !== CartStorage/* default.getInitialCart */.Z.getInitialCart()) {
      CartStorage/* default.saveCart */.Z.saveCart(cart);
    }
  }, [cart]);
  var handleShowCart = (0,react.useCallback)(function () {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isCollectionsLoading || collectionsError || productError) return;
    setShowCart(boolVal);
  }, [isCollectionsLoading, collectionsError, productError]);
  (0,react.useEffect)(function () {
    var queryCollection = router.query.collection;

    if (queryCollection) {
      var foundCollection = collections.find(function (c) {
        return c.name.trim().toLowerCase() === queryCollection.trim().toLowerCase();
      });
      setSelectedCollection(foundCollection);
    } else {
      setSelectedCollection(ALL_PRODUCTS_OBJECT);
    }
  }, [collections, router.query]);
  var setFilter = (0,react.useCallback)(function (collection) {
    queryClient.invalidateQueries(["storeProducts", store.id, collection]);
    queryClient.removeQueries(["storeProducts", store.id, selectedCollection]);
    setSelectedCollection(collection);
    router.push({
      pathname: router.pathname,
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        collection: collection.name === "all products" ? "" : collection.name
      })
    }, undefined, {
      shallow: true
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [router]);
  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);
  (0,react.useEffect)(function () {
    if (!products.length) return;

    var _products$slice = products.slice(-1),
        _products$slice2 = (0,slicedToArray/* default */.Z)(_products$slice, 1),
        lastElement = _products$slice2[0];

    setLastEl(lastElement.id);
  }, [products]);

  var updateAndSaveCart = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCartData) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCart(newCartData);
              _context2.next = 3;
              return CartStorage/* default.saveCart */.Z.saveCart(newCartData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAndSaveCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart(productId, value) {
    console.log("Product ".concat(productId, " added status: ").concat(value, " (update logic needed here if applicable)"));
  };

  if (collectionsError || productError) return /*#__PURE__*/(0,jsx_runtime.jsx)(_500["default"], {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "scrollbar-none ".concat(hasBannerWithProPlan ? "mt-0" : "mt-[38px]", " min-h-[calc(100vh-268px)] w-full px-[22px]"),
    children: [isCartInitialized && (cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : _cart$products.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
      isBasketOpen: showCart,
      setCart: updateAndSaveCart,
      cartData: cart,
      updateAddedToCart: updateAddedToCart,
      handleShowCart: handleShowCart,
      store: store,
      setRefresh: function setRefresh() {},
      isProplanActive: isProplanActive
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
      cartActive: cart.products.length > 0,
      handleShowCart: handleShowCart,
      hideInAdvance: false,
      homeActive: hasBannerWithProPlan,
      store: store,
      theme: theme,
      storeName: (store === null || store === void 0 ? void 0 : store.storeName) || "",
      toggleSideNav: function toggleSideNav() {
        return setShowSideNav(!showSideNav);
      },
      homePage: hasBannerWithProPlan
    }), isProplanActive && /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
      isOpen: showSideNav,
      toggleDrawer: function toggleDrawer() {
        return setShowSideNav(!showSideNav);
      },
      store: store
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: isCollectionsLoading || collections && collections.length > 0 ? "hide-scrollbar relative left-0 right-0 ".concat(hasBannerWithProPlan ? "top-0" : "top-14", " z-10 ").concat(hasBannerWithProPlan ? "mt-[18px]" : "mt-[5px]", " flex h-12 max-w-[500px] overflow-x-auto overflow-y-hidden scroll-smooth px-0 leading-8") : "",
      children: [collections && collections.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_StoreCollections, {
        theme: theme,
        collections: collections,
        setFilter: setFilter,
        selectedCollection: selectedCollection
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-5"
      }), isCollectionsLoading && Array(3).fill(0).map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
          className: "m-[4px_5px_5px_4px] w-[150px] rounded-[50px] px-5 py-[4px]"
        }, i);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative ".concat(hasBannerWithProPlan ? "mt-6" : "mt-4 pt-16", " grid min-h-[80vh] gap-[11px_22px]"),
      children: [products.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(RestorableList/* default */.Z, {
        children: react.Children.toArray(products.map(function (_, index) {
          var startIndex = index * 2;
          var endIndex = startIndex + 2;
          var rowProducts = products.slice(startIndex, endIndex);
          if (!rowProducts.length) return null;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-2 gap-4",
            children: react.Children.toArray(rowProducts.map(function (product) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                ref: lastEl === product.id ? ref : null,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
                  cohort: store.cohort.includes(2) ? store.cohort : null,
                  product: product,
                  top: index === 0
                })
              });
            }))
          });
        }))
      }) : !isProductsLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyStore/* default */.Z, {
        store: store
      }), (isFetchingNextPage || isProductsLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 gap-4",
        children: Array(6).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
              imageClass: "rounded-lg object-cover max-w-[none] w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]",
              titleClass: "h-4 w-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)]",
              descriptionClass: "h-4 w-[calc((100vw/2)-150px)] md:w-[calc((520px/2)-150px)]",
              containerClass: "flex justify-start items-start flex-col max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]"
            }, i)
          }, i);
        })
      })]
    })]
  });
};

/* harmony default export */ var Home_CollectionHome = (CollectionHome);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-player@2.16.1_react@18.3.1/node_modules/react-player/lib/index.js
var lib = __webpack_require__(1746);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-responsive-carousel@3.2.23/node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(6050);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-responsive-carousel@3.2.23/node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(770);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(8071);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1008);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(473);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2027);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(6035);
;// CONCATENATED MODULE: ./components/SectionHeading.jsx



var SectionHeading = function SectionHeading(_ref) {
  var label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
    className: (0,utils.cn)("bg-ap text-fontBackground text-center text-2xl font-bold", className),
    children: label
  });
};

/* harmony default export */ var components_SectionHeading = (SectionHeading);
;// CONCATENATED MODULE: ./components/Reviews/Reviews.jsx








 // type Review = {
//   _id: string;
//   storeId: string;
//   link?: string;
//   title?: string;
//   rating?: number;
//   image?: string;
//   sortOrder?: number;
//   createdAt: string;
//   updatedAt: string;
// };
// interface ReviewsProps {
//   storeId: string;
// }




var Reviews = function Reviews(_ref) {
  var storeId = _ref.storeId;

  var _useState = (0,react.useState)([]),
      reviews = _useState[0],
      setReviews = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var sortedReviews = reviews.sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
  var renderSkeletons = Array(6).fill(0).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewSkeleton, {}, i);
  });
  var renderReviews = sortedReviews.map(function (review) {
    var resolved = (0,media/* resolveImage */.rs)(review.image, review.imageV2, "review");
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
        resolved: resolved,
        alt: review.title || "Review Image",
        imgClassName: "h-[432px] min-w-[250px] rounded-2xl object-cover"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
        className: "h-[432px] min-w-[250px] rounded-2xl object-cover",
        src: resolved.src,
        alt: review.title || "Review Image",
        effect: "blur"
      })
    }, review._id);
  });
  (0,react.useEffect)(function () {
    var fetchReviews = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var response, data;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return fetch("".concat((0,helper/* getPublicServerEndpoint */.rq)(), "/v2/review/store/").concat(storeId));

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;
                setReviews(data.data);
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                console.error("Error fetching reviews:", _context.t0);
                setReviews([]);

              case 15:
                _context.prev = 15;
                setIsLoading(false);
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 15, 18]]);
      }));

      return function fetchReviews() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchReviews(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (sortedReviews.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-[50px] pl-[20px] pr-[27px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionHeading, {
      label: "Reviews"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar mt-[30px] flex gap-x-5 overflow-x-auto",
      children: isLoading ? renderSkeletons : renderReviews
    })]
  });
};

var ReviewSkeleton = function ReviewSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "h-[432px] min-w-[250px] animate-pulse rounded-2xl bg-gray-200"
  });
};

/* harmony default export */ var Reviews_Reviews = (Reviews);
// EXTERNAL MODULE: ./components/Home/featured-home.module.css
var featured_home_module = __webpack_require__(3978);
var featured_home_module_default = /*#__PURE__*/__webpack_require__.n(featured_home_module);
;// CONCATENATED MODULE: ./components/Home/FeaturedCollectionList.jsx



 // type Collection = {
//       _id: string;
//       name: string;
//       createdAt: string;
//       updatedAt: string;
//       sortOrder: number;
//       store: string;
//       isFeatured: boolean;
//       isActive: boolean;
//     }
// interface FeaturedCollectionListProps {
//   featuredCollections: Collection[];
//   isLoading: boolean;
// }




var FeaturedCollectionList = function FeaturedCollectionList(_ref) {
  var featuredCollections = _ref.featuredCollections,
      isLoading = _ref.isLoading;
  var renderSkeletons = Array(4).fill(0).map(function (_, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FeaturedCollectionList_SkeletonCard, {}, index);
  });
  var renderCollections = featuredCollections.map(function (collection) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FeaturedCollectionCard, {
      collection: collection
    }, collection._id);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-[50px] pl-[20px] pr-[27px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionHeading, {
      label: "Featured Collections"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-[30px] grid grid-cols-2 gap-x-[19px] gap-y-[36px]",
      children: isLoading ? renderSkeletons : renderCollections
    })]
  });
};

/* harmony default export */ var Home_FeaturedCollectionList = (FeaturedCollectionList);

var FeaturedCollectionCard = function FeaturedCollectionCard(_ref2) {
  var collection = _ref2.collection;
  var router = (0,next_router.useRouter)();
  var resolved = (0,media/* resolveImage */.rs)(collection.image, collection.imageV2, "collection");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onClick: function onClick() {
      return router.push("/shop?collection=".concat(collection.name));
    },
    className: "cursor-pointer",
    children: [collection.image && resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
      resolved: resolved,
      alt: "collection image",
      imgClassName: "h-[162px] w-full rounded-lg object-cover md:h-[227px]"
    }) : collection.image ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: resolved.src,
      alt: "collection image",
      className: "h-[162px] w-full rounded-lg object-cover md:h-[227px]"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-[162px] w-full rounded-lg bg-gray-200 md:h-[227px]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mt-1 text-base font-normal text-fontBackground opacity-80",
      children: collection.name
    })]
  });
};

var FeaturedCollectionList_SkeletonCard = function SkeletonCard() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-[162px] w-full rounded-lg bg-gray-200 md:h-[227px]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-1 h-6 w-24 bg-gray-200"
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(317);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/FeaturedCollectionWithProd.jsx






function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Component to display a collection with its products in a horizontal scrollable list
 *
 * @param {Object} props - Component props
 * @param {Array} props.cohort - Store cohort information
 * @param {string} props.collectionName - Name of the collection
 * @param {Array} props.productsData - Array of products in the collection
 */


var FeaturedCollectionWithProd = function FeaturedCollectionWithProd(_ref) {
  var cohort = _ref.cohort,
      collectionName = _ref.collectionName,
      productsData = _ref.productsData,
      themeData = _ref.themeData;
  var products = productsData || [];

  if (products.length === 0) {
    return null;
  }

  var formattedCollectionName = capitalizeFirstLetter(collectionName ? collectionName : "");
  var collectionUrl = "/shop?collection=".concat(encodeURIComponent(collectionName));
  var isVerticalScroll = (themeData === null || themeData === void 0 ? void 0 : themeData.collectionScrollDirection) === "vertical";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "m-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "mx-[10px] mb-[30px] mt-[50px] text-center text-xl font-bold text-fontBackground",
      children: formattedCollectionName
    }), isVerticalScroll ?
    /*#__PURE__*/
    // Vertical grid layout
    (0,jsx_runtime.jsx)("div", {
      className: "grid grid-cols-2 gap-x-3",
      children: products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
          cohort: cohort,
          product: product,
          pageSize: products.length
        }, product.id);
      })
    }) :
    /*#__PURE__*/
    // Horizontal scroll layout
    (0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap",
      children: products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
          cohort: cohort,
          usedForCollectionhome: true,
          product: product,
          pageSize: products.length
        }, product.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: collectionUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "mx-auto my-2 block w-[90px] border border-primary px-4 py-2 text-center text-sm text-primary transition duration-300 ease-in-out hover:bg-primary hover:text-fontPrimary",
        children: "View All"
      })
    })]
  });
};

/* harmony default export */ var Home_FeaturedCollectionWithProd = (FeaturedCollectionWithProd);
;// CONCATENATED MODULE: ./components/Home/FeaturedHome.jsx





























function FeaturedHome_capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var FeaturedHome = function FeaturedHome(_ref) {
  var _store$storeBanner, _cart$products;

  var theme = _ref.theme,
      store = _ref.store,
      updateHomeActive = _ref.updateHomeActive,
      heroMedia = _ref.heroMedia,
      heroMediaImages = _ref.heroMediaImages,
      heroMediaType = _ref.heroMediaType,
      heroTitle = _ref.heroTitle;

  var _useState = (0,react.useState)(CartStorage/* default.getInitialCart */.Z.getInitialCart()),
      cart = _useState[0],
      setCart = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCartInitialized = _useState2[0],
      setIsCartInitialized = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showCart = _useState3[0],
      setShowCart = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showSideNav = _useState4[0],
      setShowSideNav = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      collectionsWithProducts = _useState5[0],
      setCollectionsWithProducts = _useState5[1];

  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var isProplanActive = context.isProplanActive;
  var router = (0,next_router.useRouter)();

  var _useCollection = (0,useCollection/* default */.ZP)(store.id, ""),
      fetchedCollections = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading;

  var collections = fetchedCollections ? fetchedCollections.collections : [];
  var featuredCollections = collections.filter(function (col) {
    return col.isFeatured && col.isActive;
  }).sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
  var isVerticalScroll = (theme === null || theme === void 0 ? void 0 : theme.collectionScrollDirection) === "vertical";
  var hasFeaturedCollections = featuredCollections && featuredCollections.length > 0; // Setup intersection observer for the pagination trigger element

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.1,
    // Trigger when at least 10% of the element is visible
    triggerOnce: false
  }),
      ref = _useInView.ref,
      inView = _useInView.inView; // Initialize cart


  (0,react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var initialCartData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CartStorage/* default.initializeCart */.Z.initializeCart();

              case 2:
                initialCartData = _context.sent;
                setCart(initialCartData);
                setIsCartInitialized(true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref2.apply(this, arguments);
      };
    }();

    initialize();
  }, []);

  var updateAndSaveCart = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCartData) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCart(newCartData);
              _context2.next = 3;
              return CartStorage/* default.saveCart */.Z.saveCart(newCartData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAndSaveCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart(productId, value) {
    console.log("FeaturedHome: Product ".concat(productId, " added status: ").concat(value, " (update logic needed)"));
  };

  var handleShowCart = function handleShowCart() {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setShowCart(boolVal);
  };

  var _useCollectionsWithPr = (0,useCollection/* useCollectionsWithProducts */.ow)(store.id, 5, isVerticalScroll ? 4 : 10),
      collectionsData = _useCollectionsWithPr.data,
      isCollectionsInitialLoading = _useCollectionsWithPr.isLoading,
      isFetchingNextPage = _useCollectionsWithPr.isFetchingNextPage,
      fetchNextPage = _useCollectionsWithPr.fetchNextPage,
      hasNextPage = _useCollectionsWithPr.hasNextPage; // 5 collections per page, 10 products per collection


  (0,react.useEffect)(function () {
    if (!collectionsData) return; // Get all collections from all pages and flatten them

    var allCollections = collectionsData.pages.flatMap(function (page) {
      return page.collections || [];
    }); // Update state with the new data structure

    setCollectionsWithProducts(allCollections);
  }, [collectionsData]); // Load more collections when observer element comes into view
  // Only trigger when inView and we have more pages and we're not already loading

  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetchingNextPage]); // Render loading skeletons

  var renderLoadingSkeletons = function renderLoadingSkeletons(key) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "m-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        className: "mx-auto mb-[30px] mt-[50px] h-8 w-28 text-center font-bold text-primary"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap",
        children: Array(2).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
            className: "m-[4px_5px_5px_4px] w-[10px] rounded-[50px] px-5 py-[4px]",
            imageClass: "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]"
          }, i);
        })
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StaticInfoBanner, {
      text: store === null || store === void 0 ? void 0 : (_store$storeBanner = store.storeBanner) === null || _store$storeBanner === void 0 ? void 0 : _store$storeBanner.text
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "sticky top-0 w-full ".concat(heroMediaType === "image" ? "h-full" : "relative", " z-50 flex justify-center"),
      children: [isCartInitialized && (cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : _cart$products.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
        isBasketOpen: showCart,
        setCart: updateAndSaveCart,
        cartData: cart,
        updateAddedToCart: updateAddedToCart,
        handleShowCart: handleShowCart,
        store: store,
        setRefresh: function setRefresh() {},
        isProplanActive: isProplanActive
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
        cartActive: isCartInitialized && cart.products.length > 0,
        hideInAdvance: false,
        homeActive: true,
        storeName: heroTitle,
        handleShowCart: handleShowCart,
        store: store,
        theme: theme,
        toggleSideNav: function toggleSideNav() {
          return setShowSideNav(!showSideNav);
        },
        homePage: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
        isOpen: showSideNav,
        toggleDrawer: function toggleDrawer() {
          return setShowSideNav(!showSideNav);
        },
        store: store
      })]
    }), heroMediaType === "image" ? /*#__PURE__*/(0,jsx_runtime.jsx)(js/* Carousel */.lr, {
      autoPlay: true,
      infiniteLoop: true,
      showThumbs: false,
      showArrows: false,
      showStatus: false,
      className: (0,utils.cn)((featured_home_module_default()).carouselImageContainer),
      onClickItem: function onClickItem() {
        return router.push("/shop");
      },
      preventMovementUntilSwipeScrollTolerance: true,
      swipeScrollTolerance: 50,
      children: heroMediaImages.map(function (imageUrl, index) {
        var _store$homePage;

        var imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
        var imgurlNew = imageUrl.includes("dm2buy") ? "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(imageName, "?width=500&quality=80") : (0,cdn/* toCdnUrl */.V$)(imageUrl);
        var resolved = (0,media/* resolveImage */.rs)(imageUrl, store === null || store === void 0 ? void 0 : (_store$homePage = store.homePage) === null || _store$homePage === void 0 ? void 0 : _store$homePage.heroMediaImagesV2, "hero");

        if (resolved.isV2) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
              resolved: resolved,
              alt: imageName,
              imgClassName: "max-h-[656px] min-h-[485px] w-full object-cover pb-8",
              loading: index === 0 ? "eager" : "lazy",
              fetchpriority: index === 0 ? "high" : "auto"
            })
          }, imageName);
        }

        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imgurlNew,
            alt: imageName,
            className: "max-h-[656px] min-h-[485px] w-full object-cover pb-8",
            fetchpriority: index === 0 ? "high" : "auto"
          })
        }, imageName);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative h-screen max-h-[90vh] w-full",
      onClick: function onClick() {
        return router.push("/shop");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
        url: (0,cdn/* toCdnUrl */.V$)(heroMedia),
        playing: true,
        loop: true,
        muted: true,
        playsinline: true,
        width: "100%",
        height: "100%",
        className: (featured_home_module_default()).carouselVideoContainer
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "z-10 mt-2.5 flex w-full flex-col items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: function onClick() {
          return updateHomeActive(false);
        },
        className: "flex h-10 w-36 items-center justify-center rounded-md bg-primary text-sm text-fontPrimary",
        children: "SHOP NOW"
      })
    }), hasFeaturedCollections && /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedCollectionList, {
      featuredCollections: featuredCollections,
      isLoading: isCollectionsLoading
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "min-h-[400px] w-full",
      children: isCollectionsInitialLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: Array(2).fill(0).map(function (_, index) {
          return renderLoadingSkeletons("initial-skeleton-".concat(index));
        })
      }) : collectionsWithProducts.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [collectionsWithProducts.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedCollectionWithProd, {
            cohort: store.cohort,
            collectionName: FeaturedHome_capitalizeFirstLetter(collection.name ? collection.name : ""),
            themeData: theme,
            productsData: collection.products || []
          }, collection._id);
        }), isFetchingNextPage && renderLoadingSkeletons("loading-more-skeleton"), hasNextPage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: ref,
          className: "h-12 w-full",
          "aria-hidden": "true"
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex h-full items-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-500"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Reviews_Reviews, {
      storeId: store.id
    })]
  });
};

/* harmony default export */ var Home_FeaturedHome = (FeaturedHome);
;// CONCATENATED MODULE: ./components/Home/ScrollPositionProvider.jsx

 // Create the context


var ScrollContext = /*#__PURE__*/(0,react.createContext)(); // Create a provider component

var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(0),
      scrollPosition = _useState[0],
      setScrollPosition = _useState[1];

  var updateScrollPosition = (0,react.useCallback)(function (position) {
    setScrollPosition(position);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollContext.Provider, {
    value: {
      scrollPosition: scrollPosition,
      updateScrollPosition: updateScrollPosition
    },
    children: children
  });
}; // Custom hook to use the ScrollContext

var useScroll = function useScroll() {
  var _useState2 = useState(0),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  useEffect(function () {
    var savedPosition = localStorage.getItem("scrollPosition");

    if (savedPosition) {
      setScrollPosition(parseInt(savedPosition, 10));
    }
  }, []);

  var updateScrollPosition = function updateScrollPosition(position) {
    localStorage.setItem("scrollPosition", position);
    setScrollPosition(position);
  };

  return {
    scrollPosition: scrollPosition,
    updateScrollPosition: updateScrollPosition
  };
};
;// CONCATENATED MODULE: ./components/Home/MainHome.jsx









var MainHome = function MainHome(_ref) {
  var _store$storeBanner$te, _store$storeBanner, _store$homePage, _store$homePage2, _store$homePage3, _store$storeBanner2;

  var store = _ref.store,
      theme = _ref.theme,
      hideHeroMedia = _ref.hideHeroMedia;
  var router = (0,next_router.useRouter)();
  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var isProplanActive = context === null || context === void 0 ? void 0 : context.isProplanActive;
  var homeActive = isProplanActive && !!(store !== null && store !== void 0 && store.homePageEnabled) && !hideHeroMedia;
  var hasBanner = (_store$storeBanner$te = store === null || store === void 0 ? void 0 : (_store$storeBanner = store.storeBanner) === null || _store$storeBanner === void 0 ? void 0 : _store$storeBanner.text) !== null && _store$storeBanner$te !== void 0 ? _store$storeBanner$te : false;

  var updateHomeActive = function updateHomeActive() {
    router.push("/shop");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "w-screen max-w-app flex-auto bg-background transition-[max-height] duration-200",
    children: [homeActive ? /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedHome, {
      theme: theme,
      store: store,
      updateHomeActive: updateHomeActive,
      heroMedia: store === null || store === void 0 ? void 0 : (_store$homePage = store.homePage) === null || _store$homePage === void 0 ? void 0 : _store$homePage.heroMedia.url,
      heroMediaImages: store === null || store === void 0 ? void 0 : (_store$homePage2 = store.homePage) === null || _store$homePage2 === void 0 ? void 0 : _store$homePage2.heroMediaImages,
      heroMediaType: store === null || store === void 0 ? void 0 : (_store$homePage3 = store.homePage) === null || _store$homePage3 === void 0 ? void 0 : _store$homePage3.heroMediaType,
      heroTitle: store.homePage.heroTitle ? store.homePage.heroTitle : store.storeName
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ScrollProvider, {
      children: [isProplanActive && hasBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(StaticInfoBanner, {
        text: store === null || store === void 0 ? void 0 : (_store$storeBanner2 = store.storeBanner) === null || _store$storeBanner2 === void 0 ? void 0 : _store$storeBanner2.text
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Home_CollectionHome, {
        store: store,
        theme: theme,
        hasBanner: hasBanner
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/***/ }),

/***/ 4567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);
 // eslint-disable-next-line no-undef



var _require = __webpack_require__(5087),
    WindowVirtualizer = _require.WindowVirtualizer,
    Virtualizer = _require.Virtualizer; // --- SessionStorage Availability Check ---


function isSessionStorageAvailable() {
  try {
    if ( false || typeof window.sessionStorage === "undefined") {
      return false;
    }

    var testKey = "__restorable_list_test__";
    window.sessionStorage.setItem(testKey, testKey);
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn("SessionStorage is not available or accessible: ".concat(e.message));
    return false;
  }
}

var RestorableList = function RestorableList(_ref) {
  var children = _ref.children,
      _ref$useVirtualizer = _ref.useVirtualizer,
      useVirtualizer = _ref$useVirtualizer === void 0 ? false : _ref$useVirtualizer;
  var cacheKey = "window-list-cache-1";
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); // Check if sessionStorage is available

  var isSessionStorageAvailable = function isSessionStorageAvailable() {
    try {
      var testKey = "__storage_test__";
      window.sessionStorage.setItem(testKey, testKey);
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (e) {
      console.warn("sessionStorage not available:", e);
      return false;
    }
  }; // Safe sessionStorage getter


  var safeGetItem = function safeGetItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window, _window$sessionStorag;

        return (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem(key);
      }

      return null;
    } catch (e) {
      console.warn("Error accessing sessionStorage:", e);
      return null;
    }
  }; // Safe sessionStorage setter


  var safeSetItem = function safeSetItem(key, value) {
    try {
      if (isSessionStorageAvailable()) {
        var _window2, _window2$sessionStora;

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.setItem(key, value);
      }
    } catch (e) {
      console.warn("Error setting sessionStorage:", e);
    }
  }; // Safe sessionStorage remover


  var safeRemoveItem = function safeRemoveItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window3, _window3$sessionStora;

        (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$sessionStora = _window3.sessionStorage) === null || _window3$sessionStora === void 0 ? void 0 : _window3$sessionStora.removeItem(key);
      }
    } catch (e) {
      console.warn("Error removing from sessionStorage:", e);
    }
  }; // Add error handling for ResizeObserver


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleError = function handleError(error) {
      if (error.message.includes("ResizeObserver")) {
        error.stopPropagation();
        return false;
      }
    };

    window.addEventListener("error", handleError);
    return function () {
      return window.removeEventListener("error", handleError);
    };
  }, []);

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var serialized;
    serialized = safeGetItem(cacheKey);
    if (!serialized) return [];

    try {
      return JSON.parse(serialized); // eslint-disable-next-line no-unused-vars
    } catch (e) {
      return [];
    }
  }, []),
      offset = _useMemo[0],
      cache = _useMemo[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    if (!ref.current) return;
    var handle = ref.current;
    window.scrollTo(0, offset !== null && offset !== void 0 ? offset : 0);
    safeRemoveItem(cacheKey);
    var scrollY = 0;

    var onScroll = function onScroll() {
      scrollY = window.scrollY;
    };

    window.addEventListener("beforeunload", function () {
      safeRemoveItem(cacheKey);
    });
    window.addEventListener("scroll", onScroll);
    onScroll();
    return function () {
      window.removeEventListener("scroll", onScroll); // Use stored window.scrollY because it may return 0 in useEffect cleanup

      safeSetItem(cacheKey, JSON.stringify([scrollY, handle.cache]));
    };
  }, [offset]);

  if (useVirtualizer) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Virtualizer, {
      children: children
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WindowVirtualizer, {
    ref: ref,
    cache: cache,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RestorableList);

/***/ }),

/***/ 1284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9955);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9363);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5551);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function Skeleton(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", _objectSpread({
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("animate-pulse rounded-md bg-[#e8eaf6]", className)
  }, props));
}



/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5551);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1284);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2676);






var SkeletonCard = function SkeletonCard(_ref) {
  var _ref$imageClass = _ref.imageClass,
      imageClass = _ref$imageClass === void 0 ? "" : _ref$imageClass,
      _ref$titleClass = _ref.titleClass,
      titleClass = _ref$titleClass === void 0 ? "" : _ref$titleClass,
      _ref$descriptionClass = _ref.descriptionClass,
      descriptionClass = _ref$descriptionClass === void 0 ? "" : _ref$descriptionClass,
      _ref$containerClass = _ref.containerClass,
      containerClass = _ref$containerClass === void 0 ? "" : _ref$containerClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("flex flex-col space-y-3", containerClass),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
      className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-[125px] w-[250px] rounded-xl", imageClass)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-4 w-[250px]", titleClass)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .O, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("h-4 w-[200px]", descriptionClass)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SkeletonCard);

/***/ }),

/***/ 3531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1503);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7623);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);





var reload = function reload() {
  window.location.reload();
};

var Error500Page = function Error500Page() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/500.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "500 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: "We are over capacity! Please wait a moment and try again."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      onClick: reload,
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Refresh"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Error500Page);

/***/ }),

/***/ 3978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselImageContainer":"featured-home_carouselImageContainer__ksnob","carouselImage":"featured-home_carouselImage__3aVoz","carouselVideoContainer":"featured-home_carouselVideoContainer__Pz41Z"};

/***/ }),

/***/ 4555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infobanner":"static-infobanner_infobanner__FrEI3"};

/***/ })

}]);